var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.5l5.55 3.65M5.5 8.65L11.05 5",
    stroke: "#001464",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.4,
    cy: 10.4,
    r: 2.65,
    stroke: "#001464",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6,
    cy: 3.4,
    r: 2.65,
    stroke: "#001464",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6,
    cy: 17.4,
    r: 2.65,
    stroke: "#001464",
    strokeWidth: 1.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxNyAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNSAxMi41TDExLjA0OTkgMTYuMTQ5OSIgc3Ryb2tlPSIjMDAxNDY0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNNS41IDguNjQ5OUwxMS4wNDk5IDUiIHN0cm9rZT0iIzAwMTQ2NCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGNpcmNsZSBjeD0iMy40IiBjeT0iMTAuNCIgcj0iMi42NSIgc3Ryb2tlPSIjMDAxNDY0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8Y2lyY2xlIGN4PSIxMy42MDAyIiBjeT0iMy40IiByPSIyLjY1IiBzdHJva2U9IiMwMDE0NjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxjaXJjbGUgY3g9IjEzLjYwMDIiIGN5PSIxNy40IiByPSIyLjY1IiBzdHJva2U9IiMwMDE0NjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=";
export { SvgShare as ReactComponent };